type PusherTransport = 'ws' | 'wss';

export type PusherSocketOptions = {
    wsHost: string;
    wsPort: number;
    wssPort: number;
    forceTLS: boolean;
    enabledTransports: PusherTransport[];
};

/**
 * Soketi is reached through the same host as the API (443 for https, the URL port otherwise).
 * An empty API_URL means "this page": local apelsin.localhost, test and prod builds set API_URL.
 */
export const getPusherSocketOptions = (apiUrl?: string): PusherSocketOptions => {
    const raw = (apiUrl || process.env.API_URL || '').trim();
    const fallbackOrigin =
        typeof window !== 'undefined' ? window.location.origin : 'http://localhost';

    let url: URL;
    try {
        url = new URL(raw || fallbackOrigin);
    } catch {
        url = new URL(fallbackOrigin);
    }

    const secure = url.protocol === 'https:';
    const port = Number(url.port) || (secure ? 443 : 80);

    return {
        wsHost: url.hostname,
        wsPort: port,
        wssPort: port,
        forceTLS: secure,
        // With forceTLS pusher-js connects through the `ws` transport over TLS,
        // so leaving only `wss` disables every transport and the socket fails.
        enabledTransports: ['ws', 'wss'],
    };
};
